import { TableCell, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import styled from 'styled-components'
import React from 'react'
import { locale } from '../../locale'
import { getUserIds } from '../../state/UserById/selectors'
import { State } from '../../types'
import ClientListItemContainer from './ClientListItemContainer'

type Props = {
  userIds: string[]
}
const Style = styled.div`
  .min-caption {
    display: none;
  }
  @media screen and (max-width: 1199px) {
    .visible-wide {
      display: none;
      text-align: end;
    }
    .min-caption {
      display: block;
    }
  }
  .cell-di {
    width: 88px;
  }
  th.MuiTableCell-head.MuiTableCell-root {
    font-size: 0.8rem;
  }
`

function ClientList(props: Props) {
  return (
    <Style>
      <Typography variant="caption" className="min-caption">
        詳細カラムを省略しています。(1200px未満)
      </Typography>
      <table>
        <thead>
          <tr>
            <TableCell>{locale.client.company}</TableCell>
            <TableCell>
              <div>{locale.client.email}</div>
              <div>{locale.client.password}</div>
            </TableCell>
            <TableCell>{locale.client.name}(ユーザID)</TableCell>
            <TableCell>{locale.client.devices}</TableCell>
            <TableCell className="cell-di">
              {locale.client.allowIntegration}
              {/* <div>{locale.client.allowIntegrationP1}</div> <div>{locale.client.allowIntegrationP2}</div> */}
            </TableCell>
            <TableCell className="cell-di">
              <div>{locale.client.allowDownloadP1}</div>
              <div>{locale.client.allowDownloadP2}</div>
            </TableCell>
            <TableCell>{locale.client.contactStartDate}</TableCell>
            <TableCell>{locale.client.contactEndDate}</TableCell>
            <TableCell className="visible-wide">
              {locale.client.createdAt}
            </TableCell>
            <TableCell className="visible-wide">
              {locale.client.updatedAt}
            </TableCell>
            <TableCell>{locale.client.memo}</TableCell>
            <TableCell />
          </tr>
        </thead>
        <tbody>
          {props.userIds.map((userId, i) => (
            <ClientListItemContainer userId={userId} key={userId + String(i)} />
          ))}
        </tbody>
      </table>
    </Style>
  )
}

const conn = connect((state: State) => ({ userIds: getUserIds(state) }), {})
const ClientListContainer = conn(ClientList)

export default ClientListContainer
